<form [formGroup]="flightArrivalForm">
  <mat-form-field appearance="outline" (click)="picker.open()">
    <mat-label>{{ 'FORM.ARRIVAL_DATE' | transloco }}</mat-label>
    <input matInput [min]="startDate" [matDatepicker]="picker" formControlName="flightArrivalDate"
      (dateChange)="getArrivalFlightsByDate($event);">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker touchUi #picker></mat-datepicker>
    @if (!flightArrivalForm.controls.flightArrivalDate.valid && flightArrivalForm.controls.flightArrivalDate.touched) {
    <mat-error>
      {{ 'ERROR.DATE' | transloco }}
    </mat-error>
    }
  </mat-form-field>

  <mat-form-field class="example-full-width" appearance="outline">
    @if (isLoading) {
    <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
    }
    @if (!isLoading) {
    <mat-label>{{ 'FORM.ARRIVAL_FLIGHTNUMBER' | transloco }}</mat-label>
    }
    <input type="text" matInput formControlName="flightNumber" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayArrivalFlight"
      (optionSelected)="onArrivalFlightChange($event)">
      @for (option of filteredFlightOptions | async; track option) {
      <mat-option [value]="option">
        <div class="flex-row">
          <span class="font-weight-bold mr-2">
            {{option.flightId}}
          </span>
          @if (translate.getActiveLang() === 'sv') {
          <span class="font-weight-light">{{option.departureAirportSwedish}}</span>
          }
          @if (translate.getActiveLang() === 'en') {
          <span class="font-weight-light">{{option.departureAirportEnglish}}</span>
          }
          <span class="font-weight-light code-share">&nbsp;{{option.codeShareData}}</span>
          <div class="mr-1"></div>
          <span class="font-weight-light"> Kl:
            {{option.arrivalTime.scheduled | date: 'HH:mm'}}
          </span>
        </div>
      </mat-option>
      }
    </mat-autocomplete>
    @if (isLoading) {
    <mat-spinner matSuffix color="accent" diameter="20">
    </mat-spinner>
    }
    @if (!isLoading && !flightArrivalForm.controls.flightNumber.value) {
    <mat-icon matSuffix>flight_land</mat-icon>
    }
    @if (flightArrivalForm.controls.flightNumber.value) {
    <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="resetArrivalFlight()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>
  @if (flightArrivalForm.controls.flightNumber.invalid) {
  <span class="mat-error">
    {{ 'ERROR.ARRIVAL_FLIGHTNUMBER' | transloco }}
  </span>
  }
</form>